import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import moment from 'moment'
import { json, get } from '../../../../utils/ajax'

class BoutiqueActivityStore {

    @observable list
    @observable loading
    @observable modal
    @observable forms
    @observable pagination
    @observable page
    @observable searchForms
    @observable goods
    @observable goodsEditModal
    @observable goodsForms
    @observable goodsList
    @observable activityId
    @observable updateGoodsModal
    @observable updateGoodsForms

    constructor () {
        this.list = []
        this.loading = false
        this.modal = 'hide'
        this.goodsEditModal = 'hide'
        this.updateGoodsModal = 'hide'
        this.forms = {}
        this.pagination = {}
        this.page = {}
        this.searchForms = {}
        this.goods = []
        this.goodsForms = {
            stock:'',
            goodsIds: []
        }
        this.goodsList = []
        this.activityId = 0
        this.updateGoodsForms = {}
    }

    /**
     * 初始化页面
     */
    @action
    initListActivity = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search= {}
        Object.keys(this.searchForms).forEach(key => {
            search[`search.${key}`] = this.searchForms[key] ? this.searchForms[key] : ''
        })
        search.page = page
        search.size = 10
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activity/list`,search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
        })
    }

    /**
     * 新增活动显示模式
     */
    @action showAddEdit = () => {
        runInAction(() => {
            this.loading = true
            this.forms = {}
            this.modal = 'show'
            this.loading = false
        })
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.forms.id},
            name: {value: this.forms.name},
            type: {value: this.forms.type},
            beginTime: {value: moment(this.forms.beginTime)},
            endTime: {value: moment(this.forms.endTime)},
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            name: fields.name.value,
            type: fields.type.value,
            beginTime: fields.beginTime.value && fields.beginTime.value.valueOf(),
            endTime: fields.endTime.value && fields.endTime.value.valueOf(),
        }
        this.forms = forms
    }

    /**
     * 关闭模式
     */
    @action cancelActivity = () => {
        runInAction(() => {
            this.modal = 'hide'
            this.goodsEditModal = 'hide'
            this.updateGoodsModal = 'hide'
        })
    }

    /**
     * 新增活动 + 修改活动
     */
    @action saveActivity = async() => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activity/add`, {
                ...this.forms
            })
            if (res && res.status >= 400) {
                message.error('新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('保存成功')
                    this.forms = {}
                    this.loading = false
                })
                this.initListActivity(this.page)
            }
        }else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activity/update`, {
                ...this.forms
            })
            if (res && res.status >= 400) {
                message.error('修改失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('修改成功')
                    this.forms = {}
                    this.loading = false
                })
                this.initListActivity(this.page)
            }
        }
    }

    /**
     * 初始化活动列表，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async(id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activity/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.forms = res
            this.loading = false
            this.modal = 'show'
        })
    }

    /**
     * 活动删除
     */
    @action
    deleteActivityId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activity/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initListActivity(this.pagination.page -1)
        }else{
            await this.initListActivity(this.pagination.page)
        }
    }

    /**
     * 多条件查询
     * 平行化表单，传值给form
     */
    @computed
    get formFields() {
        let formFields = {
            name: {value: this.searchForms.name},
            type: {value: this.searchForms.type},
        }
        return formFields
    }

    /**
     * 多条件查询
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormChange = (changedFields) => {
        const fields = {...this.formFields, ...changedFields}
        let searchForms = {
            name: fields.name.value,
            type: fields.type.value,
        }
        this.searchForms = searchForms
    }

    /**
     * 重置
     */
    @action
    fieldsReset(){
        runInAction(() => {
            this.loading = true
            this.searchForms = {}
            this.initListActivity(this.page)
            this.loading = false
        })
    }

    /**
     *初始化活动商品
     */
    @action
    initActivityGoods = async (page,id) => {
        runInAction(() => {
            this.loading = true
            this.activityId = id
        })
        if (page) {
            page--
        } else if (this.page.page) {
            page = this.page.page - 1
        } else {
            page = 0
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goodsByActivity/id/${id}`,{
            page:page,
            size:10
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.goods = res.content
            this.page = {
                results: res.size,
                current: res.number + 1,
                total: res.totalElements
            }
        })
    }

    /**
     * 新增活动商品显示模式
     */
    @action showAddGoodsEdit = () => {
        runInAction(() => {
            this.loading = true
            this.goodsForms = {
                stock:'',
                goodsIds: []
            }
            this.goodsEditModal = 'show'
            this.loading = false
        })
    }

    /**
     * 添加活动商品
     * 平行化表单，传值给form
     */
    @computed
    get goodsFields() {
        let goodsFields = {
            stock: {value: this.goodsForms.stock},
            goodsIds: {value: this.goodsForms.goodsIds.slice()}
        }
        return goodsFields
    }

    /**
     * 添加活动商品
     * 将表单时对象化，绑值给store。form
     */
    @action
    onGoodsChange = (changedFields) => {
        const fields = {...this.goodsFields, ...changedFields}
        let goodsForms = {
            stock: fields.stock.value,
            goodsIds: fields.goodsIds.value
        }
        this.goodsForms = goodsForms
    }

    /**
     * 初始化商品
     */
    @action
    initListGoods = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/list`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.goodsList = res
        })
    }

    /**
     * 新增活动商品
     */
    @action saveActivityGoods = async() => {
        let arrs = this.goods.map(item => {
           return item.goodsId
        })
        let arr1 = this.goodsForms.goodsIds
        for(let i = 0;i < arr1.length;i++){
            if(arrs.indexOf(arr1[i]) !== -1){
                message.warning('有些活动商品已存在，请查看清楚再添加商品')
                runInAction(() => {
                    this.goodsEditModal = 'hide'
                })
                return
            }
        }
        runInAction(() => {
            this.loading = true
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activityGoods/activity/${this.activityId}`, {
            ...this.goodsForms
        })
        if (res && res.status >= 400) {
            message.error('新增失败')
            return
        }
        runInAction(() => {
            this.goodsEditModal = 'hide'
            message.success('保存成功')
            this.goodsForms = {
                stock:'',
                goodsIds: []
            }
            this.loading = false
        })
       await this.initActivityGoods(this.page,this.activityId)
    }

    /**
     * 初始化活动商品列表，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initUpdateGoodsEdit = async(id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activityGoods/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.updateGoodsForms = res
            this.loading = false
            this.updateGoodsModal = 'show'
        })
    }

    /**
     * 修改活动商品
     * 平行化表单，传值给form
     */
    @computed
    get updateGoodsFields() {
        let updateGoodsFields = {
            id: {value: this.updateGoodsForms.id},
            name: {value: this.updateGoodsForms.name},
            stock: {value: this.updateGoodsForms.stock},
            imgUrl: {value: this.updateGoodsForms.imgUrl},
        }
        return updateGoodsFields
    }

    /**
     * 修改活动商品
     * 将表单时对象化，绑值给store。form
     */
    @action
    onUpdateGoodsChange = (changedFields) => {
        const fields = {...this.updateGoodsFields, ...changedFields}
        let updateGoodsForms = {
            id:fields.id.value,
            name: fields.name.value,
            stock: fields.stock.value,
            imgUrl: fields.imgUrl.value,
        }
        this.updateGoodsForms = updateGoodsForms
    }

    /**
     * 图片上传
     */
    @action imageUpload = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 修改活动商品
     */
    @action updateGoods = async() => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activityGoods/update`, this.updateGoodsForms
        )
        if (res && res.status >= 400) {
            message.error('修改失败')
            return
        } else {
            runInAction(() => {
                this.updateGoodsModal = 'hide'
                message.success('修改成功')
                this.updateGoodsForms = {}
                this.loading = false
            })
            await this.initActivityGoods(this.page,this.activityId)
        }
    }

    /**
     * 活动商品删除
     */
    @action
    deleteActivityGoodsId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/activityGoods/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initActivityGoods(this.pagination.page -1,this.activityId)
        }else{
            await this.initActivityGoods(this.pagination.page,this.activityId)
        }
    }
}
export default new BoutiqueActivityStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/BoutiqueCatalog/BoutiqueActivity/store.js